import { NavSectionHeader } from "./navigation-section.header";
import { MenuItem } from "./menu-item";
import { sideNavStyle } from "./navigation.style";

type NavigationSectionProps<T = unknown> = {
  label?: string;
  items?: T[];
  emptyLabel?: string;
  renderItem: (item: T) => React.ReactNode;
  dataTestTag?: string;
};

export function NavigationSection<T>({
  label,
  items,
  emptyLabel = "No items yet...",
  renderItem,
  dataTestTag,
}: NavigationSectionProps<T>) {
  return (
    <div data-test={dataTestTag ?? "list"}>
      {!!label && <NavSectionHeader label={label} />}
      <ul className={sideNavStyle.list()}>
        {items?.length ? (
          items.map(renderItem)
        ) : (
          <MenuItem
            href="/new"
            isDisabled
          >
            {emptyLabel}
          </MenuItem>
        )}
      </ul>
    </div>
  );
}
